import React from "react";
import { useState } from "react";
import MedicineDetailsModal from "./MedicineDetailsModal";

const data = [
  {
    id: 3873,
    source: "ECLINIC",
    placedOn: "16-04-2025",
    total: "15,000.50",
    status: "Pending",
  },
  {
    id: 3873,
    source: "Swastya Mitra",
    placedOn: "Kaveri Sahoo",
    total: "2,894.04",
    status: "Cancel",
  },
  {
    id: 3873,
    source: "Swastya Mitra",
    placedOn: "Kaveri Sahoo",
    total: "2,894.04",
    status: "Confirm",
  },
  {
    id: 3873,
    source: "Swastya Mitra",
    placedOn: "Kaveri Sahoo",
    total: "2,894.04",
    status: "Cancel",
  },
  ...Array(6).fill({
    id: 3873,
    source: "Swastya Mitra",
    placedOn: "Kaveri Sahoo",
    total: "2,894.04",
    status: "Confirm",
  }),
];

const statusColor = {
  Pending: "text-yellow-500",
  Cancel: "text-red-500",
  Confirm: "text-green-400",
};

const Enquiries = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <div className="overflow-x-auto rounded-cb-md shadow-sm border-gray-200 p-3 sm:p-6">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-left">
          <thead className="bg-gray-50 text-gray-500 font-semibold">
            <tr>
              <th className="px-6 py-4">Enquiry ID</th>
              <th className="px-6 py-4">Order Source</th>
              <th className="px-6 py-4">Placed On</th>
              <th className="px-6 py-4">Total (₹)</th>
              <th className="px-6 py-4">Enquiry Status</th>
              <th className="px-6 py-4">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-6 py-4">{item.id}</td>
                <td className="px-6 py-4">{item.source}</td>
                <td className="px-6 py-4">{item.placedOn}</td>
                <td className="px-6 py-4">{item.total}</td>
                <td
                  className={`px-6 py-4 font-medium ${
                    statusColor[item.status]
                  }`}
                >
                  {item.status}
                </td>
                <td
                  className="px-6 py-4 text-blue-600 font-medium cursor-pointer hover:underline"
                  onClick={() => setIsModalOpen(true)}
                >
                  View →
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <MedicineDetailsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Enquiries;
